import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import CTAButton from './CTAButton';

const servicesChildren = [
  { to: '/agentic-ai', label: 'Agentic AI' },
  { to: '/arvr', label: 'AR/VR' },
  { to: '/meta', label: 'Meta Applications' },
];

const navAfterServices = [
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/technologies', label: 'Technologies' },
  { to: '/process', label: 'Process' },
  { to: '/contact', label: 'Contact' },
];

function isActive(pathname, to, end = false) {
  if (end) {
    return pathname === to;
  }
  return pathname === to || pathname.startsWith(`${to}/`);
}

function isServicesActive(pathname) {
  if (pathname === '/services') return true;
  return servicesChildren.some(({ to }) => isActive(pathname, to));
}

function NavLink({ to, label, end, pathname, onNavigate, className = '' }) {
  const active = isActive(pathname, to, end);
  return (
    <Link
      to={to}
      onClick={onNavigate}
      className={`${active ? 'nav-active' : ''} ${className}`.trim() || undefined}
    >
      {label}
    </Link>
  );
}

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const { pathname } = useLocation();

  const closeMenu = () => {
    setIsMenuOpen(false);
    setServicesOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen((open) => !open);
    if (isMenuOpen) {
      setServicesOpen(false);
    }
  };

  const servicesActive = isServicesActive(pathname);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/" onClick={closeMenu}>
            <img src="/rounded.png" alt="MMI" />
          </Link>
        </div>

        <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
          <NavLink to="/" label="Home" end pathname={pathname} onNavigate={closeMenu} />

          <NavLink to="/about" label="About" pathname={pathname} onNavigate={closeMenu} />

          {/* Desktop: hover dropdown */}
          <div
            className={`nav-dropdown nav-dropdown--desktop${servicesActive ? ' nav-dropdown--active' : ''}`}
          >
            <div className="nav-dropdown-trigger">
              <Link
                to="/services"
                onClick={closeMenu}
                className={servicesActive ? 'nav-active' : undefined}
              >
                Services
              </Link>
              <span className="nav-dropdown-chevron" aria-hidden="true">
                ▾
              </span>
            </div>
            <div className="nav-dropdown-menu" role="menu">
              {servicesChildren.map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  role="menuitem"
                  onClick={closeMenu}
                  className={isActive(pathname, to) ? 'nav-active' : undefined}
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          {/* Mobile: tap to expand */}
          <div className={`nav-dropdown nav-dropdown--mobile${servicesOpen ? ' is-open' : ''}${servicesActive ? ' nav-dropdown--active' : ''}`}>
            <div className="nav-dropdown-mobile-row">
              <Link
                to="/services"
                onClick={closeMenu}
                className={servicesActive ? 'nav-active' : undefined}
              >
                Services
              </Link>
              <button
                type="button"
                className="nav-dropdown-toggle"
                onClick={() => setServicesOpen((open) => !open)}
                aria-expanded={servicesOpen}
                aria-label={servicesOpen ? 'Collapse Services menu' : 'Expand Services menu'}
              >
                <span className="nav-dropdown-chevron" aria-hidden="true">
                  ▾
                </span>
              </button>
            </div>
            <div className="nav-dropdown-submenu">
              {servicesChildren.map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  onClick={closeMenu}
                  className={isActive(pathname, to) ? 'nav-active' : undefined}
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          {navAfterServices.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              label={label}
              pathname={pathname}
              onNavigate={closeMenu}
            />
          ))}

          <div className="navbar-cta-wrap navbar-cta-wrap--mobile" onClick={closeMenu}>
            <CTAButton text="Book a Call" to="/contact" icon="phone" className="navbar-cta" />
          </div>
        </div>

        <div className="navbar-end">
          <div className="navbar-cta-wrap navbar-cta-wrap--desktop" onClick={closeMenu}>
            <CTAButton text="Book a Call" to="/contact" icon="phone" className="navbar-cta" />
          </div>

          <button
            type="button"
            className="hamburger"
            onClick={toggleMenu}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
          >
            <span className={isMenuOpen ? 'open' : ''}></span>
            <span className={isMenuOpen ? 'open' : ''}></span>
            <span className={isMenuOpen ? 'open' : ''}></span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
